import gql from 'graphql-tag';

/**
 * Data of the block project-acceptance-report-verification ("Abnahmeprotokoll: Prüfung"): the
 * substructure, DC, AC and scaffolding verification states. Read through
 * `Project.blocks.acceptanceReportVerification`, which checks the block's read permission.
 */
export const PROJECT_ACCEPTANCE_REPORT_VERIFICATION_FIELDS = gql`
  fragment projectAcceptanceReportVerificationFields on ProjectAcceptanceReportVerificationBlock {
    id
    number
    substructureVerificationState
    dcVerificationState
    acVerificationState
    scaffoldingVerificationState
  }
`;
